import React from 'react'
import PropTypes from 'prop-types'
import { Form as CaptchaForm } from '../../Captcha'
import FormBody from '../FormBody'

export class Form extends React.Component {

  static propTypes = {
    onLogin:      PropTypes.func.isRequired,
    isProcessing: PropTypes.bool,
    userDefaults: PropTypes.object,
    dictionary:   PropTypes.object.isRequired,
  }

  static defaultProps = {
    userDefaults: {},
  }

  constructor(props) {
    super(props);

    this.state = {
      fields: {
        username: '',
        password: '',
      }
    }
  }

  handleChange = (e) => {
    const { target } = e

    this.setState({
      fields: {
        ...this.state.fields,
        [target.name]: target.value,
      }
    })
  }

  onResolved = (response) => {
    this.props.onLogin({
      ...this.props.userDefaults,
      ...this.state.fields,
      'g-recaptcha-response': response,
    })
  }

  render() {
    return (
      <CaptchaForm
        onResolved={ this.onResolved }
        onValidUpdate={ valid => this.state.valid = valid }
        name="loginform">
        <FormBody
          fields={ this.state.fields }
          onChange={ this.handleChange }
          isProcessing={ this.props.isProcessing }
          isValid={ this.state.valid }
          dictionary={ this.props.dictionary }/>
      </CaptchaForm>
    );
  }
}



// WEBPACK FOOTER //
// ./client/Modules/AuthNative/Form/Form.jsx